import React from 'react';
import icon from "../../assets/icons/fbIcon.svg";

export default () => (<img width={20} src={icon}/>);